<script setup>

import { ref, provide, inject, watch } from 'vue';
import ModaleEnregistrerSous from '@/components/modales/ModaleEnregistrerSous.vue';
import ModaleDernieresCommandes from '@/components/modales/ModaleDernieresCommandes.vue';
import InputSwitch from 'primevue/inputswitch';
import { apiOublierModificationsModele } from '@/services/ServiceModele.js';

const { modele } = defineProps({
  modele: Object
});

const affichageElementsMasques = ref(modele?.rapport?.affichageElementsMasques);
const affichageModaleEnregistrerSous = ref(false);
const affichageModaleDernieresCommandes = ref(false);
const boutonMenu = ref(null);

const afficherBarreFlottante = inject('afficherBarreFlottante');
const annulerDerniereCommande = inject('annulerDerniereCommande');
const refaireProchaineCommande = inject('refaireProchaineCommande');
const enregistrerSous = inject('enregistrerSous');
const gererErreurApi = inject('gererErreurApi');

const itemsMenuEnregistrer = [
	{        
		libelle: 'Enregistrer sous...',
        icones: ['fa fa-copy'],
        groupe: 1,
		commande: () => {
			affichageModaleEnregistrerSous.value = true;
		}
	},
    {
		libelle: 'Oublier les modifications et fermer',
        icones: ['fa fa-times'],
        style: 'color: var(--couleur-supprimer); ',
        groupe: 2,
		commande: () => {
			oublierModificationsModele();
		}
	},
    {
		libelle: 'Voir les dernières commandes (debugging)',
        icones: ['fa fa-history'],
        groupe: 3,
		commande: () => {
			affichageModaleDernieresCommandes.value = true;
		}
	}
];

watch(() => modele?.rapport?.affichageElementsMasques, (affichage) => {
	affichageElementsMasques.value = affichage;
});

watch(() => modele?.affichageModaleEnregistrerSous, (affichage) => {
    if (affichage != null) {
        delete modele.affichageModaleEnregistrerSous;
        affichageModaleEnregistrerSous.value = affichage;
    }
});

function basculerAffichageMenu() {
    afficherBarreFlottante({
        items: itemsMenuEnregistrer, 
        selectionItems: [],
        composantParent: boutonMenu.value
    });
}

function enregistrer() {
	if (modele.infosModele.dernierEnregistrement == null) {
		affichageModaleEnregistrerSous.value = true;
	} else {
		enregistrerSous(modele.infosModele.nomModele, true);
	}
}

function oublierModificationsModele() {
    if (confirm("Toutes les modifications seront perdues. Voulez-vous vraiment quitter sans enregistrer ?")) {
        apiOublierModificationsModele(modele.id).then(
            () => window.close(), 
            err => gererErreurApi(err));
    }
}

function basculerAffichageElementsMasques() {
	modele.basculeAffichageElementsMasques = true;
}

provide('affichageModaleEnregistrerSous', affichageModaleEnregistrerSous);

</script>

<template>
	<div class="menu-modele">
        <button 
            class="bouton annuler fa-solid fa-undo" 
            v-tooltip="'Annuler'" 
            @click="annulerDerniereCommande()" />
        <button 
            class="bouton refaire fa-solid fa-redo" 
            v-tooltip="'Refaire'" 
            @click="refaireProchaineCommande()" />
        <InputSwitch class="curseur-affich-elts-masques" 
            v-model="affichageElementsMasques"
            @change="basculerAffichageElementsMasques()" />
        <i v-if="affichageElementsMasques" class="fa-solid fa-eye icone-affich-elts-masques"
            v-tooltip="'Les éléments masqués sont affichés'" />
        <i v-else class="fa-solid fa-eye-slash icone-affich-elts-masques"
            v-tooltip="'Les éléments masqués n\'apparaissent pas'" />
        <button class="bouton enregistrer fa-solid fa-save" @click="enregistrer()" />
        <button class="bouton btn-menu fa-solid fa-caret-down" 
            ref="boutonMenu"
            @click.stop="basculerAffichageMenu" />
        <ModaleEnregistrerSous :infosModele="modele.infosModele" />
        <ModaleDernieresCommandes v-model:visible="affichageModaleDernieresCommandes" />
	</div>
</template>

<style scoped>

.menu-modele {
    display: flex;
    align-items: center;
    background-color: rgb(239, 250, 255);
    padding-left: 10px;
}

.bouton {
	height: 18px;
}

.refaire {
    margin-left: 2px;
}

.curseur-affich-elts-masques {
	margin-left: 10px;
	margin-right: 5px;
}

.icone-affich-elts-masques {
	font-size: 12px;
    margin-right: 10px;
}

.btn-menu {
    margin-right: 10px;
}

</style>